import { HorizontalContainer, Skeleton, Tooltip } from '@/components';
import { InfoIcon } from '@/components/Icons';
import { cn } from '@/lib/cn';

import { R, format } from '@/caregiverSpace/resources/Texts.resx';

import {
    formatNationalIdentifierText,
    formatNationalIdentityNumber,
    getAgeInYearsAndMonths,
} from '@/caregiverSpace/shared/lib';

type NationalIdentifierViewProps = {
    nationalIdentifier: string;
    birthdate?: string;
    className?: string;
    isInvalid?: boolean;
    isPending?: boolean;
    previousNationalIdentifier?: string;
    newNationalIdentifier?: string;
};

export const NationalIdentifierView = ({
    nationalIdentifier,
    birthdate,
    className,
    isInvalid,
    isPending,
    previousNationalIdentifier,
    newNationalIdentifier,
}: NationalIdentifierViewProps) => {
    // ATTENTION! This should not be possible, but we have partially invalid data on beta
    if (nationalIdentifier == null) {
        return null;
    }

    const ageInfo = getAgeInYearsAndMonths(birthdate);
    const formatedNationalIdentifier =
        formatNationalIdentityNumber(nationalIdentifier);

    return (
        <HorizontalContainer
            className={cn('flex-wrap items-center', className)}
            spacing="none"
        >
            <span className="pr-1">{formatedNationalIdentifier}</span>
            {ageInfo && <span>({ageInfo})</span>}
            {isPending && <Skeleton className="icon ml-2 rounded-full" />}
            {isInvalid && (
                <Tooltip
                    content={formatNationalIdentifierText(
                        R.NationalIdentifierNotVerified,
                    )}
                >
                    <InfoIcon className="cursor-pointer" variant="error" />
                </Tooltip>
            )}
            {previousNationalIdentifier && (
                <Tooltip
                    allowTextWrap={true}
                    maxWidth="200px"
                    content={format(
                        formatNationalIdentifierText(R.NewNationalIdentifier),
                        formatNationalIdentityNumber(
                            previousNationalIdentifier,
                        ),
                    )}
                >
                    <InfoIcon variant="warning" className="cursor-pointer" />
                </Tooltip>
            )}
            {newNationalIdentifier && (
                <Tooltip
                    allowTextWrap={true}
                    maxWidth="200px"
                    content={format(
                        formatNationalIdentifierText(R.OldNationalIdentifier),
                        formatNationalIdentityNumber(newNationalIdentifier),
                    )}
                >
                    <InfoIcon variant="warning" className="cursor-pointer" />
                </Tooltip>
            )}
        </HorizontalContainer>
    );
};
